import React from 'react';
import ImageProductDomain from '../../media/product-domain.png';
import * as Styles from './EmptyProducts.styles';

const HGImageProductDomain = () => {
  const alt = 'Hospedagem de Sites';

  return (
    <Styles.EmptyProductImage src={ImageProductDomain} aria-label={alt} />
  );
};

export default HGImageProductDomain;
